import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';

import { IResponseLettersView } from 'app/models/mainMenu/mainMenu';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';

import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';


@Component({
  selector: 'app-mainMenu-complaintResponse',
  templateUrl: './complaintResponse.component.html',
  styleUrls: ['./complaintResponse.component.scss'],
  // changeDetection: ChangeDetectionStrategy.Default
})

export class ComplaintResponseComponent implements OnInit {

  @Input() countyId: string = '';
  complaintResponseList: IResponseLettersView[] = [];

  displayedColumns: string[] = ['complaintId', 'complaintDateString', 'businessName', 'address', 'city', 'zipCode',
    'generatedDateString', 'sentDateString'];
  dataSource = new MatTableDataSource<IResponseLettersView>(this.complaintResponseList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    public complaintService: ComplaintService,
    public businessService: BusinessService,
    public mainMenu: MainMenuService,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.mainMenu.getResponseLetters(this.countyId).subscribe({
      next: response => {
        this.mainMenu.businessResponseList = response;
        this.complaintResponseList = response;
        this.dataSource.data = this.complaintResponseList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get business response.");
      },
    });
  }

  rowClick(row: any) {
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 3;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }


}